import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translation files
import enTranslation from '@/locales/en/translation.json'
import deTranslation from '@/locales/de/translation.json'
import frTranslation from '@/locales/fr/translation.json'
import esTranslation from '@/locales/es/translation.json'
import itTranslation from '@/locales/it/translation.json'
import plTranslation from '@/locales/pl/translation.json'

export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'es', 'it', 'pl'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  pl: 'Polski',
}

const resources = {
  en: { translation: enTranslation },
  de: { translation: deTranslation },
  fr: { translation: frTranslation },
  es: { translation: esTranslation },
  it: { translation: itTranslation },
  pl: { translation: plTranslation },
}

// Get saved language or detect from browser
const getSavedLanguage = (): SupportedLanguage => {
  const saved = localStorage.getItem('language')
  if (saved && SUPPORTED_LANGUAGES.includes(saved as SupportedLanguage)) {
    return saved as SupportedLanguage
  }

  // Detect from browser
  const browserLang = navigator.language.split('-')[0]
  if (SUPPORTED_LANGUAGES.includes(browserLang as SupportedLanguage)) {
    return browserLang as SupportedLanguage
  }

  return 'en' // Default fallback
}

i18n.use(initReactI18next).init({
  resources,
  lng: getSavedLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: true,
  },
})

export default i18n
